// extracted by mini-css-extract-plugin
module.exports = {"img-container":"Seo_img-container__1oNWf"};